import { useState, useRef, useContext, useEffect } from "react";
import MaterialTable from "@material-table/core";
import {TableDataProps, TableRowSchema} from "./Resales.type";
import TableStyle from "@components/TableStyle";
import { getColumns } from "./Table.columns";
import {useIntl} from "react-intl";
import {ShowWorksitesModal} from "./Show.worksites.modal";
import {ShowQuotationsModal} from "./Show.quotations.modal";
import Toggle from "@ui-components/Toggle";
import Placeholder from "@ui-components/Placeholder";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {createFilterParams, createOrderingParams} from "../../../components/Tables/utils";


export const Table = ({
  title,
  showPotential,
  productsOrResales,
  selectedResales,
  selectedProducts,
  selectedLines,
  selectedBdgtCls,
  analysisPeriod,
  visibilityUserId,
  valueOrQuantity,
}: TableDataProps) => {
  const intl = useIntl();
  const countryApiRequest = useCountryAxiosInstance();
  const [showWorksites, setShowWorksites] = useState();
  const [showQuotations, setShowQuotations] = useState();
  const [columns, setColumns] = useState(getColumns(
    intl,
    setShowWorksites,
    setShowQuotations,
    showPotential,
    productsOrResales,
    valueOrQuantity
  ));
  const [refresh, setRefresh] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.state.query.page = 0;
      ref.current.state.query.totalCount = 0;
      ref.current.onQueryChange();
    }
  }, [
    selectedResales,
    selectedProducts,
    selectedLines,
    selectedBdgtCls,
    analysisPeriod,
    visibilityUserId,
    productsOrResales,
    showPotential,
  ]);

  useEffect(() => {
    setColumns(getColumns(
      intl,
      setShowWorksites,
      setShowQuotations,
      showPotential,
      productsOrResales,
      valueOrQuantity
    ));
  }, [valueOrQuantity, showPotential]);

  return <div>
    <TableStyle>
      <MaterialTable
        tableRef={ref}
        title={title}
        data={async (query:any) =>{
          const filters = createFilterParams(query);
          const ordering = createOrderingParams(query);
          const payload = {
            resales_ids: selectedResales.map((resale) => resale.value),
            products: selectedProducts.map((product) => `${product.value}_${product.label}`),
            prod_line_cods: selectedLines.map((line) => line.value),
            bdg_cls_cods: selectedBdgtCls.map((bdgtCls) => bdgtCls.value),
            start_date: analysisPeriod.start,
            end_date: analysisPeriod.end,
            visibility_user_id: visibilityUserId,
            internal_users: [],
            filter_ownership: [],
            filter_status: [],
            dimension: productsOrResales,
            potential: productsOrResales === 'products' && showPotential,
            offset: (refresh?0: query.page) * query.pageSize,
            limit: query.pageSize,
            ...(ordering && { ordering }),
            ...(filters && { filters }),
          };
          const {
            items, total
          } = await countryApiRequest.post(
              "/analytics/resales-products/table",
              payload,
            );

          return {
            data: items,
            page: query.page,
            totalCount: total,
          }
        }}
        columns={columns}
        options={{
          paging: true,
          filtering: true,
          sorting: true,
          search: false
        }}
      />
      </TableStyle>
    {showWorksites &&
      <ShowWorksitesModal
        worksites={showWorksites}
        onExit={() => setShowWorksites(undefined)}
      />
    }
    {showQuotations &&
      <ShowQuotationsModal
        quotations={showQuotations}
        onExit={() => setShowQuotations(undefined)}
      />
    }
  </div>
}